import { useEffect, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

export function PwaUpdatePrompt() {
  const [show, setShow] = useState(false);
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered: () => undefined,
    onRegisterError: (err) => console.warn('PWA-Registration fehlgeschlagen', err),
  });

  useEffect(() => {
    setShow(needRefresh);
  }, [needRefresh]);

  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        background: '#0c2a4a',
        color: '#fff',
        borderRadius: 10,
        padding: '12px 16px',
        boxShadow: '0 6px 20px rgba(0,0,0,.3)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        maxWidth: 340,
      }}
    >
      <span style={{ fontSize: 13 }}>Neue Version verfügbar.</span>
      <button
        type="button"
        className="btn btn-primary btn-sm"
        onClick={() => updateServiceWorker(true)}
      >
        Aktualisieren
      </button>
      <button
        type="button"
        className="btn btn-ghost btn-sm"
        style={{ color: '#fff' }}
        onClick={() => {
          setShow(false);
          setNeedRefresh(false);
        }}
      >
        Später
      </button>
    </div>
  );
}
